import { writable } from 'svelte/store';
import type { PageEvent } from '$lib/ads/metaPixel';

// Store for page-specific Meta Pixel events
export const pageEvent = writable<PageEvent | null>(null);

// Helper function for pages to set their Meta Pixel event
export function setPageEvent(event: PageEvent | null): void {
    pageEvent.set(event);
}

// Helper function to clear the page event
export function clearPageEvent(): void {
    pageEvent.set(null);
}
